import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/Coupon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4f30175e")

_pushScopeId("data-v-4f30175e")
const _hoisted_1 = { class: "list coupon" }
const _hoisted_2 = {
  key: 0,
  class: "prize-empty"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "prize-title" }, "轉盤好禮", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "item-icon" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_5 = { class: "item-content" }
const _hoisted_6 = { class: "item-text" }
const _hoisted_7 = { class: "item-time" }
const _hoisted_8 = { class: "item-code" }
const _hoisted_9 = {
  key: 0,
  class: "item-threshold"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isValid(_ctx.recordState.result) && _ctx.recordState.result.length === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, "您還未抽獎"))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recordState.result, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "item",
              key: index
            }, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, "恭喜您在「" + _toDisplayString(item.game_name) + "」中獲得了折扣碼", 1),
                _createVNode("div", _hoisted_7, _toDisplayString(item.date), 1),
                _createVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode("input", {
                    class: "item-code__text",
                    "onUpdate:modelValue": ($event: any) => (item.prize_point = $event),
                    readonly: ""
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelText, item.prize_point]
                  ]),
                  _createVNode("div", {
                    class: "item-code__copy",
                    onClick: ($event: any) => (_ctx.copyKey($event,item.prize_point))
                  }, "複製", 8, ["onClick"])
                ]),
                (item.threshold)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, "門檻與辦法：" + _toDisplayString(item.threshold), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ], 64))
  ]))
})